import api from "../../api.js";

export const processRefund = (payload) => api.post("/frontshop/refunds/process", payload);

export const listRefundedOrders = () => api.get("/frontshop/refunds/refunded-orders");
